<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    mounted:function () {
      if(window.sessionStorage.userIcon){this.$store.state.userInfo.icon = window.sessionStorage.userIcon}
      if(window.sessionStorage.groupName){this.$store.state.userInfo.groupName = window.sessionStorage.groupName}
      if(window.sessionStorage.companyName){this.$store.state.userInfo.companyName = window.sessionStorage.companyName}
      if(window.sessionStorage.fullName){this.$store.state.userInfo.fullName = window.sessionStorage.fullName}
      if(window.sessionStorage.companyShortName){this.$store.state.userInfo.companyShortName = window.sessionStorage.companyShortName}
    },
  }
</script>